<template>
  <el-row>
    <el-button @click="$router.back()" class="btn-xzma">{{title}}</el-button>
  </el-row>
</template>

<script>
  export default {
    name: "button-back",
    props: {
      title: {
        type: String,
        default: '返回'
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ButtonBack.vue